import { GraphQLTypes } from '../../services/graphql/types.graphql';

/**
 * Object that contains information about payment method (id, provider).
 * If object contains deposit or/and cashout keys
 * then payment method supports deposit or/and cashout payment actions
 * respectively and corresponding value provides information about processing time, min/max amounts and commissions.
 */
export type PaymentMethod = GraphQLTypes.SitePaymentMethod & {
  currency: string;
  custom_img: string;
  img: string;
};

export type SavedAccount = GraphQLTypes.SiteSavedAccount;

export enum PaymentPageAction {
  DEPOSIT = 'deposit',
  CASHOUT = 'cashout',
}

/**
 * Payment action (deposit or cashout)
 */
export enum PaymentAction {
  DEPOSIT = 'DEPOSIT',
  WITHDRAWAL = 'WITHDRAWAL',
}

/**
 * Payment tab type (crypto, fiat or cashout)
 */
export enum PaymentTabType {
  CRYPTO = 'crypto',
  FIAT = 'fiat',
  BUY_CRYPTO = 'buy-crypto'
};

/**
 * Cookie name of last used fiat currency
 */
export const LAST_USED_FIAT_CURRENCY = 'LAST_USED_FIAT_CURRENCY';

/**
 * Cookie name of last used crypto currency
 */
export const LAST_USED_CRYPTO_CURRENCY = 'LAST_USED_CRYPTO_CURRENCY';
